import { LegacyIIQApi } from '../legacy-iiq-api';

export const getFaqs =
  ({ legacyIIQApi: api }: { legacyIIQApi: LegacyIIQApi }) =>
  () =>
    api.get(`/faqs`).then((res) => res?.data);

export const postFaq =
  ({ legacyIIQApi: api }: { legacyIIQApi: LegacyIIQApi }) =>
  (params: Record<string, any>) =>
    api.post(`/faqs`, params).then((res) => res?.data);

export const getFaq =
  ({ legacyIIQApi: api }: { legacyIIQApi: LegacyIIQApi }) =>
  (faqId: string, params: Record<string, any>) =>
    api.get(`/faqs/${faqId}`, params).then((res) => res?.data);

export const patchFaq =
  ({ legacyIIQApi: api }: { legacyIIQApi: LegacyIIQApi }) =>
  (faqId: string, params: Record<string, any>) =>
    api.patch(`/faqs/${faqId}`, params).then((res) => res?.data);
